import { BaseModel } from '@/models/BaseModel';
import { BaseCollection } from './BaseCollection';
import type { MutationsObject } from '@kp/js-model';
import type { Dayjs } from 'dayjs';
import dayjs from 'dayjs';
import { createModel } from '@kp/js-model';

export class HgtUndAtd extends BaseModel {
    // properties
    id: number | null = null;
    created: Dayjs | null = null;
    modified: Dayjs | null = null;
    creator_id: number | null = null;
    modifier_id: number | null = null;
    heizgradtage: number | null = null;
    gewichtung_heizgradtage: number | null = null;
    akkumulierte_temperaturdifferenzen: number | null = null;
    gewichtung_akkumulierte_temperaturdifferenzen: number | null = null;

    jahr: number | null = null;
    kanton_id: number | null = null;

    // view fields
    kanton_kuerzel: string | null = null;
    kanton: string | null = null;

    public mutations(): MutationsObject {
        return {
            created: (val) => dayjs(val),
            modified: (val) => dayjs(val),
        };
    }

    getClassName(): string {
        return 'HgtUndAtd';
    }
}

export async function createNewHgtUndAtd(): Promise<HgtUndAtd> {
    const model = createModel(HgtUndAtd, {});

    await model.save();
    return model;
}

export class HgtUndAtdCollection extends BaseCollection<HgtUndAtd> {
    protected modelCls = HgtUndAtd;

    public getModelClassName(): string {
        return 'HgtUndAtd';
    }
}
